module.exports = __webpack_public_path__ + "static/media/bg3.c19b2c8.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/bg3.mp4
// module id = M7bQ
// module chunks = 0